import { FC } from "react";
import { Badge, Image } from "../../primitives";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { TextBody } from "../../typography/TextBody";
import {
  CARD_INFO_BADGE_MAP,
  CARD_INFO_CLASS_MAP,
  INFO_CARD_DEFAULTS,
  TInfoCardProps,
} from "./Card.config";
import { cn } from "@/ui/lib";

export const InfoCard: FC<TInfoCardProps> = ({
  variant = INFO_CARD_DEFAULTS.variant,
  image,
  badge,
  title,
  body,
}) => {
  return (
    <article
      data-component="InfoCard"
      className={
        cn(
          CARD_INFO_CLASS_MAP[variant],
          "py-2 px-1 rounded-sys-sm flex space-x-3",
        )
      }
    >
      { image ? (
        <div className="w-[70px] flex-none">
          <Image {...image} />
        </div>
      ) : null }
      <div className="flex flex-col space-y-1">
        <Badge {...badge} variant={CARD_INFO_BADGE_MAP[variant].variant}/>
        <TextSubtitle size={3} isResponsive={false}>{ title }</TextSubtitle>
        <TextBody size={2} isResponsive={false}>{ body }</TextBody>
      </div>
    </article>
  );
};
